import {Button, Group} from "@mantine/core";
import {useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {DateInput} from "../../date/DateInput/DateInput";
import {isBefore} from "@ots-frontend/ots-data"

type FromToDateToolbarProps = {
    defaultValues?: {
        fromDate?: Date
        toDate?: Date
    }
    onSubmit?: (fromDate: Date, toDate: Date | undefined) => void
    loading?: boolean
}

export const FromToDateToolbar = (props: FromToDateToolbarProps) => {
    const {defaultValues, onSubmit, loading} = props;

    const {t} = useTranslation(["common"]);

    const form = useForm({
        initialValues: {
            fromDate: defaultValues?.fromDate,
            toDate: defaultValues?.toDate,
        },
        validate: {
            toDate: (value, values) => {
                let error: string | undefined = undefined
                if (value && values.fromDate && isBefore(value, values.fromDate)) {
                    error = t<string>("common.form.validation.todatebeforefrom", "The to date can't be before the from date")
                }
                return error
            }
        }
    });

    const onFormSubmit = useCallback(async (values: typeof form.values) => {
        if (onSubmit) {
            onSubmit(values.fromDate!, values.toDate)
        }
    }, [form, onSubmit])

    return (
        <Group position="apart" p="xs">
            <Group position="center">

            </Group>
            <Group position="center">
                <form onSubmit={form.onSubmit(onFormSubmit)}>
                    <Group position="center" align="flex-end">
                        <DateInput
                            valueFormat="MM/DD/YYYY HH:mm"
                            label={t("common.ui.toolbar.fromtodate.form.field.fromdate", "From Date")}
                            placeholder={t<string>("common.ui.toolbar.fromtodate.form.field.fromdate", "From Date")}
                            clearable
                            withAsterisk
                            popoverProps={{
                                withinPortal: true
                            }}
                            styles={{wrapper: {width: "200px"}}}
                            required
                            {...form.getInputProps("fromDate")} />
                        <DateInput
                            miw={100}
                            valueFormat="MM/DD/YYYY HH:mm"
                            label={t("common.ui.toolbar.fromtodate.form.field.todate", "To Date")}
                            placeholder={t<string>("common.ui.toolbar.fromtodate.form.field.todate", "To Date")}
                            clearable
                            popoverProps={{
                                withinPortal: true
                            }}
                            styles={{wrapper: {width: "200px"}}}
                            {...form.getInputProps("toDate")} />
                        <Button type="submit" loading={loading} variant="outline">
                            {t("common.action.submit", {ns: "common"})}
                        </Button>
                    </Group>
                </form>
            </Group>
            <Group position="center">

            </Group>
        </Group>
    );
};
